import DefaultFormat from './default_format.helper'

export default class DermatologicaFormat extends DefaultFormat {
}
